import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { getMetadata } from 'pages/PSPPage/utils/getMetadata';
import { buildPSPUrl } from 'pages/PSPPage/utils/buildSchema';

export function PSPMeta({ keyword, normalizedSlug, contentType }) {
	const metadata = getMetadata(keyword, contentType);
	const canonicalUrl =
		contentType === 'SGP'
			? `https://www.selfstorage.com/self-storage-sizes/${keyword}/`
			: buildPSPUrl(keyword);

	const heroImageUrl =
		contentType === 'SGP'
			? `https://www.selfstorage.com/images/sgp/SGPHero/${keyword}-hero.webp`
			: `https://www.selfstorage.com/images/psp/PSPHero/${normalizedSlug}-hero.webp`;

	return (
		<Helmet>
			<title>{metadata?.title}</title>
			<link
				rel="preload"
				as="image"
				href={heroImageUrl}
				fetchPriority="high"
			/>
			<link
				rel="canonical"
				href={canonicalUrl}
			/>
			<meta
				name="description"
				content={metadata?.description}
			/>
			<meta
				property="og:title"
				content={metadata?.title}
			/>
			<meta
				property="og:description"
				content={metadata?.description}
			/>
			<meta
				property="og:url"
				content={canonicalUrl}
			/>
			<meta
				property="og:type"
				content="website"
			/>
			<meta
				property="og:image"
				content={heroImageUrl}
			/>
			<meta
				property="og:site_name"
				content="SelfStorage.com"
			/>
			<meta
				name="twitter:card"
				content="summary_large_image"
			/>
			<meta
				name="twitter:site"
				content="@selfstorage"
			/>
			<meta
				name="twitter:title"
				content={metadata?.title}
			/>
			<meta
				name="twitter:description"
				content={metadata?.description}
			/>
			<meta
				name="twitter:image"
				content={heroImageUrl}
			/>
		</Helmet>
	);
}

PSPMeta.propTypes = {
	keyword: PropTypes.string,
	normalizedSlug: PropTypes.string,
	contentType: PropTypes.string,
};

PSPMeta.defaultProps = {
	contentType: 'PSP',
};
